<template>
    <div>
        <b-card style="height:400px">
            <div class="loading">
            <div class="effect-1 effects"></div>
            <div class="effect-2 effects"></div>
            <div class="effect-3 effects"></div>
            </div>
        </b-card>
    </div>
</template>

<script>
    import { BCard } from 'bootstrap-vue';

    export default {
        components: {
            BCard,
        },
    }
</script>

<style lang="scss" scoped>

</style>